import { Injectable } from '@angular/core';
import { ObjetoEnum } from '@core/auth/objeto.enum';
import { PerfilEnum } from '@core/auth/permissoes-acesso';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuPrincipalService {

  constructor() { }

  menuPrincipal() {
    return of([
      {
        title: 'Dashboard',
        id: 'dashboard',
        url: '/dashboard',
        requiredPermissions: [
          PerfilEnum.Administracao,
          ObjetoEnum.TelaDashboard
        ],
        icon: 'ri--home-line',
        active: true,
        mobile: true
      },
      {
        title: 'Administração',
        id: 'administracao',
        icon: 'tabler--edit',
        url: '/mobile/administracao',
        requiredPermissions: [
          PerfilEnum.Administracao,
          ObjetoEnum.TelaAcessoEmail,
          ObjetoEnum.TelaPerfil,
          ObjetoEnum.TelaPermissoesPorPerfil,
          ObjetoEnum.TelaProduto,
          ObjetoEnum.TelaUsuario
        ],
        subItem: [
          // {
          //   title: 'Configurações',
          //   url: '/administracao/sistema'
          // },
          {
            title: 'Acesso por E-mail',
            url: '/administracao/acesso-email',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaAcessoEmail]
          },
          // {
          //   title: 'Batch IA',
          //   url: '/administracao/batch-capitulo-sinopse',
          //   requiredPermissions: [PerfilEnum.Administracao]
          // },
          {
            title: 'Perfil',
            url: '/administracao/perfil',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaPerfil]
          },
          {
            title: 'Permissões por Perfil',
            url: '/administracao/perfil-permissao',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaPermissoesPorPerfil]
          },
          {
            title: 'Produto',
            url: '/administracao/produto',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaProduto]
          },
          {
            title: 'Ocorrências',
            url: '/administracao/ocorrencia',
            requiredPermissions: [PerfilEnum.Administracao]
          },
          {
            title: 'Usuário',
            url: '/administracao/usuario',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaUsuario]
          },
        ]
      },
      {
        title: 'Fluxo de Cadastro',
        id: 'cadastros',
        icon: 'material-symbols-light--select-window',
        url: '/mobile/cadastros',
        requiredPermissions: [
          PerfilEnum.Administracao,
          ObjetoEnum.TelaCena,
          ObjetoEnum.TelaCapitulo,
          ObjetoEnum.TelaRoteiro
        ],
        subItem: [
          {
            title: 'Cena',
            url: '/cadastro/cena',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaCena]
          },
          {
            title: 'Capítulo',
            url: '/cadastro/capitulo',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaCapitulo]
          },
          {
            title: 'Roteiro',
            url: '/cadastro/roteiro',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRoteiro]
          }
        ]
      },
      {
        title: 'Cadastros Individuais',
        id: 'cadastros',
        icon: 'material-symbols-light--select-window',
        url: '/mobile/cadastros',
        requiredPermissions: [
          PerfilEnum.Administracao,
          ObjetoEnum.TelaAgenda,
          ObjetoEnum.TelaAmbiente,
          ObjetoEnum.TelaAnimal,
          ObjetoEnum.TelaCargo,
          ObjetoEnum.TelaCenario,
          ObjetoEnum.TelaEquipe,
          ObjetoEnum.TelaEstudio,
          ObjetoEnum.TelaFigurante,
          ObjetoEnum.TelaGravacao,
          ObjetoEnum.TelaLocacao,
          ObjetoEnum.TelaMaterial,
          ObjetoEnum.TelaPersonagem,
          ObjetoEnum.TelaRoupa,
          ObjetoEnum.TelaVeiculo
        ],
        subItem: [
          {
            title: 'Agenda',
            url: '/cadastro/agenda',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaAgenda]
          },
          {
            title: 'Ambiente',
            url: '/cadastro/ambiente',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaAmbiente]
          },
          {
            title: 'Animal',
            url: '/cadastro/animal',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaAnimal]
          },
          {
            title: 'Cargo',
            url: '/cadastro/cargo',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaCargo]
          },
          {
            title: 'Cenário',
            url: '/cadastro/cenario',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaCenario]
          },
          {
            title: 'Equipe',
            url: '/cadastro/equipe',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaEquipe]
          },
          {
            title: 'Estúdio',
            url: '/cadastro/estudio',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaEstudio]
          },
          {
            title: 'Figurante',
            url: '/cadastro/figurante',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaFigurante]
          },
          // {
          //   title: 'Gravação',
          //   url: '/cadastro/gravacao',
          //   requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaGravacao]
          // },
          {
            title: 'Locação',
            url: '/cadastro/locacao',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaLocacao]
          },
          {
            title: 'Material',
            url: '/cadastro/material',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaMaterial]
          },
          {
            title: 'Personagem',
            url: '/cadastro/personagem',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaPersonagem]
          },
          {
            title: 'Roupa',
            url: '/cadastro/roupa',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRoupa]
          },
          {
            title: 'Veículo',
            url: '/cadastro/veiculo',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaVeiculo]
          }
        ]
      },
      {
        title: 'Relatório',
        id: 'relatorio',
        icon: 'mdi--graph-bar',
        url: '/mobile/relatorio',
        requiredPermissions: [
          PerfilEnum.Administracao,
          ObjetoEnum.TelaRelatorioBingo,
          ObjetoEnum.TelaRelatorioCapituloContinuidadeBotaoExibir,
          ObjetoEnum.TelaRelatorioCapitulosFinalizados,
          ObjetoEnum.TelaRoteiroBotaoDecupagemArtistica,
          ObjetoEnum.TelaRelatorioEstatisticaGravacao,
          ObjetoEnum.TelaRelatorioFiguranteRoupa,
          ObjetoEnum.TelaRelatorioPedidoRoupa,
          ObjetoEnum.TelaRelatorioRoteiro,
          ObjetoEnum.TelaRelatorioPersonagemRoupa,
          ObjetoEnum.TelaRelatorioCapitulo,
          ObjetoEnum.TelaRelatorioCapituloContinuidade,

        ],
        subItem: [
          {
            title: 'Bingo',
            url: '/relatorio/visao-geral',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioBingo]
          },
          {
            title: 'Capítulo',
            url: '/relatorio/capitulo',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioCapitulo]
          },
          {
            title: 'Capítulo/Continuidade',
            url: '/relatorio/capitulo-continuidade',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioCapituloContinuidade]
          },
          {
            title: 'Capítulos Finalizados',
            url: '/relatorio/capitulos-finalizados',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioCapitulosFinalizados]
          },
          // {
          //   title: 'Controle de Gravação',
          //   url: '/relatorio/controle-de-gravacao',
          //   // requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioGravacao]
          // },
          {
            title: 'Decupagem Artística',
            url: '/relatorio/roteiro-decupagem',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRoteiroBotaoDecupagemArtistica]
          },
          {
            title: 'Estatísticas de Gravação',
            url: '/relatorio/estatistica-gravacao',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioEstatisticaGravacao]
          },
          // {
          //   title: 'Gravação',
          //   url: '/relatorio/gravacao',
          //   // requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioGravacao]
          // },
          {
            title: 'Pedido de Roupa',
            url: '/relatorio/roupa-pedido',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioPedidoRoupa]
          },
          {
            title: 'Roteiro',
            url: '/relatorio/roteiro',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioRoteiro]
          },
          {
            title: 'Roteiro de Continuidade',
            url: '/relatorio/roteiro-continuidade',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioRoteiro]
          },
          // {
          //   title: 'Roteiro de Arte',
          //   url: '/relatorio/roteiro-arte',
          //   // requiredPermissions: [PerfilEnum.Administracao]
          // },
          {
            title: 'Personagens/Roupa',
            url: '/relatorio/personagem-roupa',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioPersonagemRoupa]
          },
          {
            title: 'Figurante/Roupa',
            url: '/relatorio/figurante-roupa',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioFiguranteRoupa]
          },
          {
            title: 'Ocorrência',
            url: '/relatorio/ocorrencia',
            requiredPermissions: [PerfilEnum.Administracao, ObjetoEnum.TelaRelatorioOcorrencias]
          },
        ]
      },
      {
        title: 'Sair',
        icon: 'iconamoon--exit',
        url: 'sair',
        mobile: true
      }
    ])
  }
}